import { useTranslation } from 'react-i18next';

import { Box, Container, LogoLight, Text } from '@brand/components';

const Footer = (): JSX.Element => {
  const { i18n, t } = useTranslation(['footer', 'common']);
  return (
    <Box bgColor="heading" p="24px" textAlign="center">
      <Container display="flex" flexDirection="column" gap={[4, null, 8]}>
        <Box
          alignItems="center"
          display="flex"
          flexDirection={['column', null, 'row']}
          justifyContent="space-between"
        >
          <LogoLight height={12} mb={['8', '0', null]} width="auto" />
          <Box>
            <Text color="lightBlue" mb={0} size="sm" variant="preHeader">
              {t('openingHours')}
            </Text>
            <Text color="white" size="sm">
              {t('hoursAndDays')}
            </Text>
          </Box>
          <Box>
            <Text color="lightBlue" mb={0} size="sm" variant="preHeader">
              {t('telephone.title')}
            </Text>
            <Text
              _hover={{ textDecoration: 'underline' }}
              color="white"
              size="sm"
            >
              <a href="tel:+32 460 23 02 57">{t('telephone.value')}</a>
            </Text>
          </Box>
          <Box>
            <Text color="lightBlue" mb={0} size="sm" variant="preHeader">
              {t('email.title')}
            </Text>
            <Text
              _hover={{ textDecoration: 'underline' }}
              color="white"
              size="sm"
            >
              <a href="mailto:info@jaimy.be">{t('email.value')}</a>
            </Text>
          </Box>
        </Box>
        <Box
          color="placeholder"
          display="flex"
          flexDirection={['column', null, 'row']}
          gap={[1, null, 8]}
          justifyContent="flex-start"
        >
          <Text color="white" size="xs">
            © Jaimy by Belfius 2022
          </Text>
          <Text
            _hover={{ textDecoration: 'underline' }}
            color="white"
            size="xs"
          >
            <a
              href={`https://cdn.jaimy.be/pdf/Privacy+chart+-+${i18n.language}.pdf`}
              rel="noreferrer"
              target="_blank"
            >
              {t('privacyPolicy.title')}
            </a>
          </Text>
          <Text
            _hover={{ textDecoration: 'underline' }}
            color="white"
            size="xs"
          >
            <a
              href={`https://cdn.jaimy.be/pdf/Rik+PP+-+Terms+%26+Conditions+-+${i18n.language}.pdf`}
              rel="noreferrer"
              target="_blank"
            >
              {t('termsAndConditions.title')}
            </a>
          </Text>
          <Text
            _hover={{ textDecoration: 'underline' }}
            color="white"
            size="xs"
          >
            <a href={t('common:cookies.url')} rel="noreferrer" target="_blank">
              {t('common:cookies.policy')}
            </a>
          </Text>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
